(function () {
  const TOAST_HOST_ID = 'map-toast-host';

  function ensureHost() {
    let host = document.getElementById(TOAST_HOST_ID);
    if (host) return host;

    host = document.createElement('div');
    host.id = TOAST_HOST_ID;
    host.className = 'map-toast-host';
    host.setAttribute('aria-live', 'polite');
    host.setAttribute('aria-atomic', 'false');
    document.body.appendChild(host);
    return host;
  }

  /**
   * @param {string} message
   * @param {{ variant?: 'info' | 'success' | 'error', duration?: number }} [options]
   */
  function showToast(message, options = {}) {
    const variant = options.variant || 'info';
    const duration = options.duration ?? 4000;
    const host = ensureHost();

    const toast = document.createElement('div');
    toast.className = `map-toast map-toast--${variant}`;
    toast.setAttribute('role', variant === 'error' ? 'alert' : 'status');
    toast.textContent = message;

    host.appendChild(toast);

    requestAnimationFrame(() => {
      toast.classList.add('is-visible');
    });

    window.setTimeout(() => {
      toast.classList.remove('is-visible');
      window.setTimeout(() => toast.remove(), 200);
    }, duration);
  }

  /** @type {Window & { MapToast?: { show: typeof showToast } }} */
  const win = window;

  win.MapToast = { show: showToast };

  document.querySelectorAll('[data-toast-demo]').forEach((trigger) => {
    trigger.addEventListener('click', () => {
      const message = trigger.getAttribute('data-toast-message') || 'Notification';
      const variant = trigger.getAttribute('data-toast-variant') || 'info';
      showToast(message, { variant });
    });
  });
})();
